import React from 'react';
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from 'react-router-dom';

import store from './store.js';

import App from './pages/App.js';

import './css/index.css';
import './css/App.css';
import './css/prism.css';

import './css/FullSize.css';
import './css/Thumbnail.css';

const root = createRoot(document.getElementById('root'));

// Render the main React component (<App />).
root.render(
	<Provider store={store}>                   {/* The <Provider> component is supplied by Redux.         */}
  {/*
  * React router element with set base URL (environment variable retrieved from
  * "homepage" attribute in package.json) used for deployment to a subdirectory.
  * React's route switcher element
  */}
    <Router basename={process.env.PUBLIC_URL}>
		  <App />                                  {/* All React output will be contained within this element. */}
    </Router>
	</Provider>,
);
